module.exports = __webpack_public_path__ + "static/hero_pc_detail-036ce1e492567a759a02ba05710acdee.png";